import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { colors, getColor } from '@/views/pages/companyTags/colors';
import { isNotBlank, isValidLength, required } from '@/lib/rule';
import sharedMessages from '@/lib/shared-messages';
import { VForm } from 'vuetify/lib/components';
import { CompanyTagFormData, useTagComposable } from '@/composables/useTag';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyTagFormDialog',
  props: {
    value: { type: Boolean },
    selectedTag: null
  },
  emits: ["input", "submitted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'submitted'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean; // Dialog open/close
  selectedTag?: CompanyTagFormData;
};





const { createCompanyTag, updateCompanyTag } = useTagComposable();
const isValidForm = ref<boolean>(false);
const isSubmitting = ref<boolean>(false);
const form = ref<InstanceType<typeof VForm> | null>(null);
const formData = ref<CompanyTagFormData>({ name: '', color: 0 });

// for Dialog control
const localValue = ref(props.value);
watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);
const closeDialog = () => {
  if (isSubmitting.value) {
    return;
  }
  formData.value = { name: '', color: 0 };
  emit('input', false);
};

watch(
  () => props.selectedTag,
  (newValue) => {
    if (newValue) {
      formData.value = {
        name: newValue.name,
        color: newValue.color,
        id: newValue.id,
      };
    }
  }
);

const handleSubmit = async () => {
  if (isSubmitting.value) {
    return;
  }
  isSubmitting.value = true;
  try {
    if (formData.value.id) {
      await updateCompanyTag(
        formData.value.id,
        formData.value.name,
        formData.value.color
      );
    } else {
      await createCompanyTag(formData.value);
    }
    emit('submitted');
  } finally {
    isSubmitting.value = false;
  }
  closeDialog();
};

return { __sfc: true,props, emit, createCompanyTag, updateCompanyTag, isValidForm, isSubmitting, form, formData, localValue, closeDialog, handleSubmit, colors, getColor, isNotBlank, isValidLength, required, sharedMessages, VForm }
}

})